import './style.scss';
import { Timer } from '../../../js/components/Timer/Timer';
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'
import { pushDSPCounter } from '../../../js/libs/pixel';
import UiModal from '../../../js/components/UiModal/UiModal';
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'

export default !function () {
  const block = document.querySelector('.start-screen-v2');

  if (!block) {
    return;
  }

  // init timer
  const timerWrapper = block.querySelector('.start-screen-v2__timer-block')

  if (timerWrapper) {
    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper }))
  }

  // попап с детальной информацией
  const detailsButton = block.querySelector('.start-screen-v2__more');
  const detailsTemplate = block.querySelector('#start-screen-v2-details');

  if (detailsButton && detailsTemplate) {
    const detailsElement = detailsTemplate.content.querySelector('.start-screen-v2-popup__wrapper');

    detailsButton.addEventListener('click', (evt) => {
      evt.preventDefault();

      new UiModal(detailsElement, { wrapperClass: 'start-screen-v2-popup' }).init();
    });
  }

  /* hide banner */
  const bar = block.querySelector('.start-screen-v2__bar');

  if (bar) {
    const tariffs = document.querySelectorAll('#tariffs');
    const blocksWithForm = document.querySelectorAll('.block form');
    const blocks = [...blocksWithForm, ...tariffs];

    let visibleCount = 1;

    const changeVisibleButton = (entries) => {
      entries.forEach(entry => {
        entry.isIntersecting ? ++visibleCount : --visibleCount;
        visibleCount = visibleCount > 0 ? visibleCount : 0;

        visibleCount
          ? bar.classList.add('start-screen-v2__bar--hidden')
          : bar.classList.remove('start-screen-v2__bar--hidden');
      })
    };

    const observer = new IntersectionObserver(changeVisibleButton, {rootMargin: '150px'});

    blocks.forEach(block => {
      observer.observe(block);
    })
  }
  /* end hide banner */

  // analytics
  block.addEventListener('click', (evt) => {
    const target = evt.target.closest('[data-analytics]');

    if (!target) {
      return;
    }

    switch (target.dataset.analytics) {
      case 'tooltip':
        window.$analytics && window.$analytics.push('start-screen-tooltip-click');
        break;

      case 'details':
        window.$analytics && window.$analytics.push('start-screen-details-click');
        break;

      case 'conditions':
        window.$analytics && window.$analytics.push('start-screen-conditions-click');
        break;

      case 'subscribe': {
        const button = target.closest('.start-screen-v2__button');

        if (!button) {
          return
        }

        const buttonType = button.dataset.actionButton || (button.dataset.redirectLink && 'redirect')
        const blockName = target.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'

        if (buttonType === 'order-modal') {
          showOrderModal({ blockName })
        }

        target.dataset.pixel && pushDSPCounter(target.dataset.pixel);
        window.$analytics?.push('all-block-consult-button-click', {
          blockName,
          buttonType,
          buttonText: button.textContent
        })
        break;
      }
    }
  });
}();
